import {
    createAnimation,
    keyframes,
    styled,
} from '../../Styles/stitches.config'

const slideIn = (from: 'bottom' | 'left' | 'right' | 'top') =>
    keyframes({
        '0%': {
            [from]: '-100%',
        },
        '100%': {
            [from]: '0',
        },
    })

export const StyledDrawer = styled('div', {
    bgc: '$white',
    gap: '$2',
    p: '$3',
    position: 'absolute',
    transition: '$slow',

    variants: {
        open: {
            true: {},
            false: {},
        },
        position: {
            bottom: {
                ...createAnimation(slideIn('bottom'), 0.4),
                borderTop: '1px solid $neutral300',
                inset: 'auto 0 0',
            },
            left: {
                ...createAnimation(slideIn('left'), 0.4),
                borderRight: '1px solid $neutral300',
                inset: '0 auto 0 0',
            },
            right: {
                ...createAnimation(slideIn('right'), 0.4),
                borderLeft: '1px solid $neutral300',
                inset: '0 0 0 auto',
            },
            top: {
                ...createAnimation(slideIn('top'), 0.4),
                borderBottom: '1px solid $neutral300',
                inset: '0 0 auto',
            },
        },
    },

    compoundVariants: [
        {
            open: false,
            position: 'bottom',
            css: {
                bottom: '-100%',
            },
        },
        {
            open: false,
            position: 'left',
            css: {
                left: '-100%',
            },
        },
        {
            open: false,
            position: 'right',
            css: {
                right: '-100%',
            },
        },
        {
            open: false,
            position: 'top',
            css: {
                top: '-100%',
            },
        },
    ],
})
